module.exports = "<nav class=\"s-submenu\">\r\n  <ul>\r\n    <li [title]=\"item.Label\" *ngFor=\"let item of _Items\" (click)=\"OnClickLink(item)\" [ngClass]=\"'btn btn-default '+ (item._active?'s-item-active':'')+(item.Disable? ' s-item-disable ': ' ')\">\r\n      <i forIcon [ngClass]=\"'fas '+ item.IconCls \"></i>\r\n      <div text>{{item.Label}}</div>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/s-submenu/s-submenu.component.html
// module id = ./src/app/shared/components/s-submenu/s-submenu.component.html
// module chunks = main